import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, Dialog, DialogActions } from '@mui/material';
import { NavigateFunction } from 'react-router-dom';

import Payment from '../components/trial/Payment';
import AGB from '../components/AGB';
import {
  Enrollment,
  RootState, Trial,
} from '../redux/types';
import {
  showNotification,
  showErrorNotification,
  setLoading,
} from '../redux/actions';
import ApiClient from '../loopback/apiClient';

type State = {
  enrolled?: boolean;
  enrollment?: Enrollment;
  error?: string | React.ReactElement;
}

class SubscriptionConfirmationDialog extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: undefined,
    };
  }

  render() {
    const {
      trial,
      onClose,
      open,
      locale,
      showNotification: showNotificationAction,
      showErrorNotification: showErrorNotificationAction,
      navigate,
      setLoading: dispatchSetLoading,
    } = this.props;
    const {
      enrolled,
      enrollment,
      error: errorState,
    } = this.state;
    const actions = [
      <Button
        key="cancel"
        variant="contained"
        color="secondary"
        onClick={onClose}
      >
        <FormattedMessage id="trialConfirmation.cancel" />
      </Button>,
      <Button
        key="confirm"
        id="TrialEnrollmentConfirmation-button"
        variant="contained"
        color="primary"
        onClick={() => {
          if (!trial) {
            return;
          }
          dispatchSetLoading(true);
          ApiClient.enrollToTrial(trial)
            .then((enrollmentRes) => {
              if (trial.priceInEUR === 0) {
                onClose();
                navigate('/Enrollments');
                return;
              }
              this.setState({
                enrolled: true,
                enrollment: enrollmentRes,
              });
            })
            .catch((error) => {
              if (error.status === 403) {
                switch (error.message) {
                  case 'TRIAL_FULL':
                    showErrorNotificationAction(<FormattedMessage id="voucher.trialFull" />);
                    break;
                  case 'INSTITUTE_UNAPPROVED':
                    showNotificationAction(<FormattedMessage id="trials.instituteUnapproved" />);
                    break;
                  case 'INSTITUTE_ENROLL_RESTRICTED':
                    showErrorNotificationAction('Enrollment in this Trial is restricted for your country. Please contact Quip');
                    break;
                  case 'NO_INSTITUTE':
                    showErrorNotificationAction('You do not have any institute registered. Please Contact Quip Administrator');
                    break;
                  default:
                    showErrorNotificationAction(error.message);
                }
              } else {
                showErrorNotificationAction(error.message);
              }
            })
            .finally(() => dispatchSetLoading(false));
        }}
      >
        <FormattedMessage id="trialConfirmation.confirm" />
      </Button>,
    ];
    if (!trial) {
      return null;
    }
    return (
      <>
        {
          trial && (
            <div>
              <Dialog
                scroll="paper"
                open={open}
                maxWidth="lg"
              >
                {
                  !enrolled
                    ? (
                      <div className="pa4">
                        <AGB
                          locale={locale}
                        />
                      </div>
                    )
                    : (
                      <Payment
                        trial={trial}
                        enrollment={enrollment}
                        onCancel={onClose}
                        navigate={navigate}
                      />
                    )
                }
                {
                  errorState
                  && <p style={{ color: 'red' }}>{errorState}</p>
                }
                {
                  !enrolled && (
                    <DialogActions>
                      {actions}
                    </DialogActions>
                  )
                }
              </Dialog>
            </div>
          )
        }
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  locale: state.intl.locale,
});

const dispatchProps = {
  showNotification,
  showErrorNotification,
  setLoading,
};

const connector = connect(mapStateToProps, dispatchProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & {
  trial?: Trial;
  open: boolean;
  onClose: () => void;
  navigate: NavigateFunction;
};

export default connector(SubscriptionConfirmationDialog);
